const debug = require('debug')('latency-monitor:LatencyMonitor');

export function isBrowser() {
    return typeof window !== 'undefined';
}
